/**
 * useCurrency Hook
 *
 * Returns the currency of the ACTIVE brand (its company's, cf
 * `resolveCurrentCurrency`) — not the user's own company.
 * Defaults to 'EUR' if no company is available.
 *
 * @see US-2.5.5 - Multi-Currency Support
 */

import { useAuth } from '@/context/AuthContext';
import type { Currency } from '@bstock/shared';
import { resolveCurrentCurrency } from '@bill/core-types';

/**
 * Hook to get the current company's currency
 * @returns The currency code (ISO 4217) of the company
 */
export function useCurrency(): Currency {
  const { user } = useAuth();

  return resolveCurrentCurrency(user);
}
